export default "__VITE_ASSET__c7d658db__"